export const CarriersTypes = [
    { id: 1, name: 'Юр. лицо' },
    { id: 2, name: 'Физ. лицо' },
    { id: 3, name: 'ИП' },
]
